import React from 'react'
import { Icon, Tooltip, Input } from '@components/UI'

const Search = ({ value, onChange }) => {
  return (
    <div className='control-container dark'>
      <button>
        <Icon name='search medium' />
      </button>
      <Tooltip
        style={{ padding: 0, height: '32px', width: '220px' }}
        className='theme color-f background-a border'
        group='c7'
        content={
          <div
            className='tooltip-content'
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <Input
              style={{ width: '100%' }}
              placeholder='Filter files by name'
              value={value}
              events={{ onChange }}
            />
          </div>
        }
      />
    </div>
  )
}

export default Search
